import { Component, OnInit, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import { ButtonModule } from 'primeng/button';
import { DatePickerModule } from 'primeng/datepicker';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DialogModule } from 'primeng/dialog';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputTextarea } from 'primeng/inputtextarea';
import { ProgramacionServicio } from 'src/app/domain/model/orden-servicio/orden-servicio';
import { EncabezadoDetalleOrdenComponent } from '../components/encabezado-detalle-orden/encabezado-detalle-orden.component';
import { ResumenDetalleOrdenComponent } from '../components/resumen-detalle-orden/resumen-detalle-orden.component';
import { TablaProgramacionesDetalleOrdenComponent } from '../components/tabla-programaciones-detalle-orden/tabla-programaciones-detalle-orden.component';
import { InformacionTareasDetalleFacade } from '../services/informacion-tareas-detalle.facade';
import {
  IT_DETALLE_ANULAR_RECHAZO_JUSTIFICACION_MAX,
  IT_DETALLE_ANULAR_RECHAZO_JUSTIFICACION_MIN,
  IT_DETALLE_ANULAR_RECHAZO_TITULO_MODAL,
  IT_DETALLE_COLSPAN_CON_MODIFICAR,
  IT_DETALLE_MENSAJE_NO_PROGRAMACIONES
} from '../services/informacion-tareas-detalle.constants';
import { LoadingOverlayComponent } from '../../shared/loading-overlay.component';
import { sanitizeTextarea } from 'src/app/common/input-utils';

/**
 * HU2 MVP3 - Detalle de Orden en Informacion de Tareas.
 *
 * Legacy: DetalleOrdenViewImpl / DetalleOrdenActivity.
 *
 * Container (Smart Component): orquesta facade y delega UI en componentes
 * dumb para cumplir skill componentes-reutilizables.
 */
@Component({
  selector: 'app-informacion-tareas-detalle',
  standalone: true,
  imports: [
    ToastModule,
    FormsModule,
    ConfirmDialogModule,
    DialogModule,
    DatePickerModule,
    InputNumberModule,
    InputTextarea,
    ButtonModule,
    LoadingOverlayComponent,
    EncabezadoDetalleOrdenComponent,
    ResumenDetalleOrdenComponent,
    TablaProgramacionesDetalleOrdenComponent
  ],
  providers: [MessageService, InformacionTareasDetalleFacade],
  template: `
    <div class="p-4 max-w-full mx-auto flex flex-col gap-4">
      <p-toast></p-toast>

      <app-loading-overlay [blocked]="facade.loading()"></app-loading-overlay>

      <app-encabezado-detalle-orden
        [titulo]="facade.titulo"
        [breadcrumbModulo]="facade.breadcrumbModulo"
        [codigoOrden]="facade.detalle()?.codigoOrden"
        (verDetalle)="onVerDetalleEmpresa()"
        (regresar)="onRegresar()"
      >
      </app-encabezado-detalle-orden>

      <app-resumen-detalle-orden
        [detalle]="facade.detalle()"
        [mostrarBloqueAnularRechazo]="facade.mostrarBloqueAnularRechazo()"
        [habilitarAccionAnularRechazo]="facade.habilitarAccionAnularRechazo()"
        [tooltipAnularRechazo]="facade.tooltipAnularRechazo()"
        (anularRechazo)="onIniciarAnularRechazo()"
      >
      </app-resumen-detalle-orden>

      <app-tabla-programaciones-detalle-orden
        [programaciones]="facade.programaciones()"
        [cargando]="facade.cargandoProgramaciones()"
        [descargandoActaId]="facade.descargandoActaId()"
        [mostrarColumnaModificar]="true"
        [colspan]="colspanConModificar"
        [mensajeSinProgramaciones]="mensajeSinProgramaciones"
        [puedeMostrarModificar]="facade.puedeMostrarModificar.bind(facade)"
        (descargarActa)="onDescargarActa360($event)"
        (modificar)="onModificarCumplimiento($event)"
      >
      </app-tabla-programaciones-detalle-orden>

      <p-confirmDialog
        key="confirmarModificarProgramacion"
        [style]="{ width: '420px', maxWidth: '95vw' }"
      ></p-confirmDialog>

      <p-dialog
        [visible]="facade.mostrarModalAnularRechazo()"
        [modal]="true"
        [draggable]="false"
        [resizable]="false"
        [closable]="!facade.guardandoAnularRechazo()"
        [style]="{ width: '42rem', maxWidth: '95vw' }"
        [header]="tituloModalAnularRechazo"
        (visibleChange)="onVisibleChangeModalAnularRechazo($event)"
      >
        <div class="flex flex-col gap-3">
          <p class="text-sm text-gray-600 m-0">
            Ingrese la justificacion para anular la solicitud de rechazo de la orientacion.
          </p>

          <div class="flex flex-col gap-2">
            <label for="justificacionAnularRechazo" class="font-semibold text-sm">
              Justificacion <span class="text-red-500">*</span>
            </label>
            <textarea
              id="justificacionAnularRechazo"
              pInputTextarea
              rows="5"
              [attr.maxlength]="justificacionAnularRechazoMax"
              [autoResize]="true"
              [ngModel]="facade.justificacionAnularRechazo()"
              (ngModelChange)="
                facade.setJustificacionAnularRechazo(sanitizeTextarea($event))
              "
            >
            </textarea>
            <small class="text-gray-500 text-right block">
              {{ facade.justificacionAnularRechazoLength() }}/{{ justificacionAnularRechazoMax }}
            </small>
            <small class="text-gray-500">
              Minimo {{ justificacionAnularRechazoMin }} caracteres.
            </small>
          </div>
        </div>

        <ng-template pTemplate="footer">
          <div class="flex flex-wrap justify-end sm:justify-start gap-3 w-full">
            <p-button
              label="Cancelar"
              severity="secondary"
              [outlined]="true"
              [disabled]="facade.guardandoAnularRechazo()"
              (onClick)="onCerrarModalAnularRechazo()"
            >
            </p-button>
            <p-button
              label="Confirmar"
              [loading]="facade.guardandoAnularRechazo()"
              (onClick)="onConfirmarAnularRechazo()"
            >
            </p-button>
          </div>
        </ng-template>
      </p-dialog>

      <p-dialog
        [visible]="facade.mostrarModalModificar()"
        [modal]="true"
        [draggable]="false"
        [resizable]="false"
        [closable]="!facade.guardandoModificacion()"
        [style]="{ width: '42rem', maxWidth: '95vw' }"
        header="Modificar programación"
        (visibleChange)="onVisibleChangeModalModificar($event)"
      >
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div class="flex flex-col gap-2">
            <label for="fechaProgramacionEditar" class="font-semibold text-sm"
              >Fecha de programación (aaaa/mm/dd)
              <span class="text-red-500">*</span></label
            >
            <p-datepicker
              inputId="fechaProgramacionEditar"
              [showIcon]="true"
              [appendTo]="'body'"
              [dateFormat]="'yy/mm/dd'"
              [ngModel]="facade.fechaProgramacionEditar()"
              (ngModelChange)="facade.setFechaProgramacionEditar($event)"
            >
            </p-datepicker>
          </div>

          <div class="flex flex-col gap-2">
            <label for="horaInicioEditar" class="font-semibold text-sm"
              >Hora de inicio (HH:mm)
              <span class="text-red-500">*</span></label
            >
            <input
              id="horaInicioEditar"
              type="time"
              class="p-inputtext p-component w-full"
              [ngModel]="facade.horaInicioEditar()"
              (ngModelChange)="facade.setHoraInicioEditar($event)"
            />
          </div>

          <div class="flex flex-col gap-2">
            <label for="duracionEditar" class="font-semibold text-sm"
              >Duración <span class="text-red-500">*</span></label
            >
            <p-inputNumber
              inputId="duracionEditar"
              mode="decimal"
              [min]="0"
              [minFractionDigits]="0"
              [maxFractionDigits]="2"
              [ngModel]="facade.duracionEditar()"
              (ngModelChange)="facade.setDuracionEditar($event)"
            >
            </p-inputNumber>
          </div>

          <div class="flex flex-col gap-2">
            <label for="fechaAprobacionEditar" class="font-semibold text-sm"
              >Fecha de aprobación (aaaa/mm/dd)</label
            >
            <p-datepicker
              inputId="fechaAprobacionEditar"
              [showIcon]="true"
              [appendTo]="'body'"
              [dateFormat]="'yy/mm/dd'"
              [ngModel]="facade.fechaAprobacionEditar()"
              (ngModelChange)="facade.setFechaAprobacionEditar($event)"
            >
            </p-datepicker>
          </div>

          <div class="flex flex-col gap-2 md:col-span-2">
            <label for="justificacionEditar" class="font-semibold text-sm"
              >Justificación <span class="text-red-500">*</span></label
            >
            <textarea
              id="justificacionEditar"
              pInputTextarea
              rows="4"
              [autoResize]="true"
              [ngModel]="facade.justificacionEditar()"
              (ngModelChange)="
                facade.setJustificacionEditar(sanitizeTextarea($event))
              "
            >
            </textarea>
          </div>
        </div>

        <ng-template pTemplate="footer">
          <div class="flex flex-wrap justify-end sm:justify-start gap-3 w-full">
            <p-button
              label="Cancelar"
              severity="secondary"
              [outlined]="true"
              [disabled]="facade.guardandoModificacion()"
              (onClick)="onCerrarModalModificar()"
            >
            </p-button>
            <p-button
              label="Guardar"
              [loading]="facade.guardandoModificacion()"
              (onClick)="onGuardarModificarCumplimiento()"
            >
            </p-button>
          </div>
        </ng-template>
      </p-dialog>
    </div>
  `
})
export class InformacionTareasDetalleComponent implements OnInit {
  readonly facade = inject(InformacionTareasDetalleFacade);
  sanitizeTextarea = sanitizeTextarea;
  readonly mensajeSinProgramaciones = IT_DETALLE_MENSAJE_NO_PROGRAMACIONES;
  readonly colspanConModificar = IT_DETALLE_COLSPAN_CON_MODIFICAR;
  readonly tituloModalAnularRechazo = IT_DETALLE_ANULAR_RECHAZO_TITULO_MODAL;
  readonly justificacionAnularRechazoMin =
    IT_DETALLE_ANULAR_RECHAZO_JUSTIFICACION_MIN;
  readonly justificacionAnularRechazoMax =
    IT_DETALLE_ANULAR_RECHAZO_JUSTIFICACION_MAX;

  async ngOnInit(): Promise<void> {
    await this.facade.init();
  }

  async onRegresar(): Promise<void> {
    await this.facade.regresar();
  }

  async onVerDetalleEmpresa(): Promise<void> {
    await this.facade.irInformacionEmpresa();
  }

  async onDescargarActa360(programacion: ProgramacionServicio): Promise<void> {
    await this.facade.descargarActa360(programacion);
  }

  async onModificarCumplimiento(
    programacion: ProgramacionServicio
  ): Promise<void> {
    await this.facade.iniciarModificarCumplimiento(programacion);
  }

  onIniciarAnularRechazo(): void {
    this.facade.iniciarAnularRechazo();
  }

  onVisibleChangeModalAnularRechazo(visible: boolean): void {
    if (!visible) {
      this.facade.cerrarModalAnularRechazo();
    }
  }

  onCerrarModalAnularRechazo(): void {
    this.facade.cerrarModalAnularRechazo();
  }

  async onConfirmarAnularRechazo(): Promise<void> {
    await this.facade.confirmarAnularRechazo();
  }

  onVisibleChangeModalModificar(visible: boolean): void {
    if (!visible) {
      this.facade.cerrarModalModificarCumplimiento();
    }
  }

  onCerrarModalModificar(): void {
    this.facade.cerrarModalModificarCumplimiento();
  }

  async onGuardarModificarCumplimiento(): Promise<void> {
    await this.facade.guardarModificarCumplimiento();
  }
}
